import React from "react";

function AppHome() {
  return (
    <svg
      width="30"
      height="25"
      x="0"
      y="0"
      viewBox="0 0 569.859 569.858"
      class=""
    >
      <g>
        <path
          d="M414.142 0H155.707c-21.248 0-38.422 17.212-38.422 38.441v492.976c0 21.238 17.184 38.441 38.422 38.441h258.436c21.229 0 38.432-17.203 38.432-38.441V38.441C452.564 17.212 435.363 0 414.142 0zM284.294 546.392c-13.378 0-24.203-10.815-24.203-24.184 0-13.359 10.824-24.184 24.203-24.184 13.331 0 24.184 10.824 24.184 24.184 0 13.368-10.863 24.184-24.184 24.184zm116.395-92.871c0 5.843-4.734 10.586-10.586 10.586H179.728c-5.852 0-10.576-4.743-10.576-10.586V74.004a10.568 10.568 0 0 1 10.576-10.576h210.366c5.852 0 10.586 4.733 10.586 10.576v379.517h.009z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
          class=""
        />
        <path
          d="M291.16 180.674c-3.453-3.022-8.999-2.955-12.365.144l-76.28 69.921a8.06 8.06 0 0 0-.373 11.59l1.913 1.989c3.165 3.299 8.3 3.691 11.437.87l5.709-5.106v74.741c0 4.58 3.72 8.3 8.3 8.3h29.729a8.29 8.29 0 0 0 8.291-8.3v-52.288h37.934v52.288c-.076 4.58 3.213 8.3 7.785 8.3h31.518a8.3 8.3 0 0 0 8.301-8.3v-73.688s1.568 1.377 3.51 3.088c1.939 1.702 6.014.335 9.094-3.06l2.16-2.372a8.105 8.105 0 0 0-.66-11.609l-76.003-66.508z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
          class=""
        />
      </g>
    </svg>
  );
}

export default AppHome;
